var render = function render(){var _vm=this,_c=_vm._self._c;return _c('confirm-dialog',{staticClass:"border",attrs:{"title":_vm.title,"message":_vm.message,"showDialog":_vm.showDialog,"no-icons":true},on:{"cancel":_vm.handleCancel,"confirm":_vm.handleConfirm}})
}
var staticRenderFns = []

export { render, staticRenderFns }